import { render, staticRenderFns } from "./MedicalData.vue?vue&type=template&id=94bfeee0&scoped=true&"
import script from "./MedicalData.vue?vue&type=script&lang=js&"
export * from "./MedicalData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94bfeee0",
  null
  
)

export default component.exports